document.addEventListener('DOMContentLoaded', function() {

  function getRelativePosition(element, relativeElement) {
    const elementRect = element.getBoundingClientRect();
    const relativeElementRect = relativeElement.getBoundingClientRect();
    return {
      top: absint(elementRect.top - relativeElementRect.top),
      right: absint(elementRect.right - relativeElementRect.right),
      bottom: absint(elementRect.bottom - relativeElementRect.bottom),
      left: absint(elementRect.left - relativeElementRect.left)
    };
  }

  function absint(number) {
    return parseInt(String(number).replace('-', ''), 10);
  }

  function visualyDebug(selector) {
    const elements = typeof(selector) == 'string' ? document.querySelectorAll(selector) : [selector];
    elements.forEach(function(element) {
      element.style.outline = '1px solid red';
    });
  }

  function refreshZone(zone) {
    const originalStickyElements = zone.parentElement.querySelectorAll('.js-sticky-element');

    const firstStickyElementRelativePosition = getRelativePosition(originalStickyElements[0], zone.parentElement);
    const lastStickyElementRelativePosition = getRelativePosition(originalStickyElements[originalStickyElements.length - 1], zone.parentElement);
    zone.style.inset = firstStickyElementRelativePosition.top + 'px ' + firstStickyElementRelativePosition.right + 'px ' + lastStickyElementRelativePosition.bottom + 'px ' + firstStickyElementRelativePosition.left + 'px';

    const zoneRect = zone.getBoundingClientRect();
    if (zoneRect.width <= 1) {
      return false;
    }
    Array.from(zone.children).forEach(function(child) {
      child.style.maxWidth = zoneRect.width + 'px';
    });

    return true;
  }

  function afterRefreshZoneOk(zone, stickyElements) {
    window.addEventListener('resize', function() {
      refreshZone(zone);
    });

    stickyElements[0].classList.add('is-active');
    document.addEventListener('scroll', function() {
      stickyElements.forEach(function(element) {
        if (!element.classList.contains('is-active')) {
          return;
        }

        const oldParent = zone.parentElement.querySelector('[data-sticky-id="' + element.dataset.stickyParent + '"]');
        const oldParentRect = oldParent.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        if (oldParentRect.bottom < elementRect.bottom - elementRect.height / 2) {
          if (element.nextElementSibling) {
            element.classList.remove('is-active');
            element.nextElementSibling.classList.add('is-active');
          }
        }
        else if (oldParentRect.top > elementRect.top + elementRect.height / 2) {
          if (element.previousElementSibling) {
            element.classList.remove('is-active');
            element.previousElementSibling.classList.add('is-active');
          }
        }
      });
    });
    document.dispatchEvent(new Event('scroll'));
  }

  document.querySelectorAll('.js-sticky-zone').forEach(function(zone) {
    // visualyDebug(zone);

    const originalStickyElements = zone.parentElement.querySelectorAll('.js-sticky-element');
    const stickyElements = [];
    originalStickyElements.forEach(function(element) {
      const clone = element.cloneNode(true);
      clone.classList.remove('js-sticky-element');
      stickyElements.push(clone);
      zone.appendChild(clone);
    });
    zone.parentElement.classList.add('is-ready');

    const afterRefreshZoneOkTimeout = function() {
      if (refreshZone(zone)) {
        afterRefreshZoneOk(zone, stickyElements);
      }
      else {
        setTimeout(afterRefreshZoneOkTimeout, 100);
      }
    };
    afterRefreshZoneOkTimeout();
  });

  // document.querySelectorAll('.c-expertises__item').forEach(function(item) {
  //   visualyDebug(item);
  // });

});
